import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[sliceHover]',
  inputs: ['targetDiv', 'index'],
})
export class SliceHoverDirective {
  @Input()
  set index(i: number) {
    this._index = i;
    this.renderer.setStyle(
      this.elementRef.nativeElement,
      'transform',
      `rotate(${this.index * 60}deg) skewY(-30deg)`
    );
    let iconRotation = 360 - 60 * i;
    this.renderer.setStyle(
      this.elementRef.nativeElement.children[0],
      'transform',
      `skewY(30deg) rotate(${iconRotation}deg)`
    );
    this.renderer.setStyle(
      this.elementRef.nativeElement.children[1],
      'transform',
      `skewY(30deg) rotate(${iconRotation}deg)`
    );
  }

  get index() {
    return this._index;
  }

  @HostListener('mouseover') onMouseOver(event: any) {
    if (!this.elementRef.nativeElement.disabled) {
      this.renderer.addClass(this.targetDiv, 'primary-bg');
    }
  }
  @HostListener('mouseleave') onMouseLeave(event: any) {
    this.renderer.removeClass(this.targetDiv, 'primary-bg');
  }

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef<HTMLButtonElement>
  ) {}
  targetDiv?: HTMLElement;
  private _index: number = 0;
}
